import {
    Box, Card, CardContent, Grid, useMediaQuery, TextField, InputAdornment, CircularProgress,
    Stack, Button, Avatar, Typography,
} from "@mui/material";
import ChatContacts from "./contacts";
import Convo from "./convo";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState, useRef } from "react";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import WhatsAppLoader from "../../../components/loaders/whatsappLoader";
import FilterMultiSelect from "../../../components/selections/filterMultiSelect";
import { fieldRootSx } from "../../../components/selections/fieldTheme";
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { setSelectUser, clearWaMessageChats, clearLoader } from "../messagesSlice";
import { getContactFilters } from "../messagesThunk";
import { getTemplateThunk } from '../../templates/templatesThunk';
import InfiniteScroll from "react-infinite-scroll-component";
import { getChatContacts, getWaChatsThunk, updateMessagesCountThunk } from "../messagesThunk";
import ConvoNavBar from "./convoNavBar";
import ConvoFooter from "./convoFooter";
import { SocketProvider } from "../../../components/socketProvider/socketProvider";
import convoBg from '../../../assests/convoBg.jpg';
import SearchIcon from '@mui/icons-material/Search';


// Height of the contacts + chat block (both columns use it so their bottoms line up)
const PANEL_HEIGHT = { xs: "calc(100vh - 84px)", md: 480 }; // xs/sm: full height below the 62px top bar

export default function WhatsAppLayout() {
    const dispatch = useDispatch();
    const lastMsgRef = useRef(null);
    const isMobile = useMediaQuery("(max-width:899.95px)"); // matches the md breakpoint used by the Grid columns below
    const { error, status, waContactUserFilterArr, selectedUser, waMessageChats, waMessageContacts, hasMore, page, loading, hasMoreChats, loadingChats, chatPage } = useSelector((state) => state.messages);

    const [state, setState] = useState({
        selectedBrachDeptValue: [],
        selectedTagValue: [],
        selectQrCodeValue: [],
        selectOrganizationValue: [],
        searchUser: "",
        activeButton: 0,
    });

    const { selectedBrachDeptValue, selectedTagValue, selectQrCodeValue, selectOrganizationValue, searchUser, activeButton } = state;

    const prepareFilterValues = (selectedValues, allOptions) => {
        if (!selectedValues || selectedValues.length === 0 || selectedValues.length === allOptions.length) {
            return [];
        }
        return selectedValues.map((v) => v.value);
    };

    useEffect(() => {
        dispatch(
            getChatContacts({
                page: 1,
                limit: activeButton === 0 ? 50 : 100,
                filterType: activeButton,
                branch_department_ids: prepareFilterValues(selectedBrachDeptValue, waContactUserFilterArr.branchDepartments),
                tag_ids: prepareFilterValues(selectedTagValue, waContactUserFilterArr.tags),
                qr_code_ids: prepareFilterValues(selectQrCodeValue, waContactUserFilterArr.qrCodes),
                organisation_ids: prepareFilterValues(selectOrganizationValue, waContactUserFilterArr.organisations),
                search: searchUser?.trim() || "",
            })
        );

        setState((prev) => ({ ...prev, activeButton: 0 }));

    }, [dispatch, selectedBrachDeptValue, selectedTagValue, selectQrCodeValue, selectOrganizationValue, searchUser]);


    const fetchNext = () => {
        if (!loading && hasMore) {
            dispatch(
                getChatContacts({
                    page: page + 1,
                    limit: activeButton === 0 ? 50 : 100,
                    filterType: activeButton,
                    branch_department_ids: prepareFilterValues(selectedBrachDeptValue, waContactUserFilterArr.branchDepartments),
                    tag_ids: prepareFilterValues(selectedTagValue, waContactUserFilterArr.tags),
                    qr_code_ids: prepareFilterValues(selectQrCodeValue, waContactUserFilterArr.qrCodes),
                    organisation_ids: prepareFilterValues(selectOrganizationValue, waContactUserFilterArr.organisations),
                    search: searchUser?.trim() || "",
                })
            );
        }
    };


    const handleMultiSelectChange = (name, selectedValues) => {
        setState((prev) => ({
            ...prev,
            [name]: selectedValues,
            errors: { ...prev.errors, [name]: "" },
        }));
        dispatch(setSelectUser(null));
    };


    useEffect(() => {
        dispatch(getContactFilters());
        dispatch(clearWaMessageChats());
        dispatch(getTemplateThunk());
    }, [dispatch]);

    useEffect(() => {
        if (searchUser !== null) {
            dispatch(updateMessagesCountThunk());
        }
    }, [selectedUser, dispatch])

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    useEffect(() => {
        if (status === "failed") {
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    }, [status, error]);

    useEffect(() => {
        if (waContactUserFilterArr) {
            setState({
                selectedBrachDeptValue: waContactUserFilterArr.branchDepartments || [],
                selectedTagValue: waContactUserFilterArr.tags || [],
                selectQrCodeValue: waContactUserFilterArr.qrCodes || [],
                selectOrganizationValue: waContactUserFilterArr.organisations || [],
            });
        }
    }, [waContactUserFilterArr]);

    // Escape key listener
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                dispatch(setSelectUser(null));
                dispatch(clearWaMessageChats());
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [dispatch]);



    const scrollToLastMsg = () => {
        // Bring the last message into view by scrolling ONLY the chat panel
        // (same result as scrollIntoView, but without scrolling the page / wrappers,
        // which pushed the whole block under the fixed top bar).
        const scrollPanel = () => {
            const chatPanel = document.getElementById("scrollableChatDiv");
            const lastMsg = lastMsgRef?.current;
            if (!chatPanel || !lastMsg) return;
            const panelRect = chatPanel.getBoundingClientRect();
            const msgRect = lastMsg.getBoundingClientRect();
            chatPanel.scrollTop += msgRect.bottom - panelRect.bottom + 16; // 16px breathing room
        };
        // after render, and again shortly after (late-loading images/videos change the height)
        requestAnimationFrame(scrollPanel);
        setTimeout(scrollPanel, 300);
    };

    useEffect(() => {
        if (chatPage === 1) {
            scrollToLastMsg();
        }
    }, [waMessageChats, chatPage]);

    const fetchPreviousChat = () => {
        if (!loadingChats && hasMoreChats && selectedUser !== null) {
            dispatch(
                getWaChatsThunk({
                    credentials: {
                        wa_contact_id: selectedUser,
                        limit: 20,
                        page: chatPage + 1,
                    },
                })
            );
        }
    };


    useEffect(() => {
        if (selectedUser !== null) {
            dispatch(
                getWaChatsThunk({
                    credentials: {
                        wa_contact_id: selectedUser,
                        limit: 20,
                        page: 1,
                    },
                })
            );
        }
    }, [dispatch, selectedUser]);

    // When a chat is selected, scroll the PAGE so the whole chat block sits just below the
    // fixed top bar (nothing cut off). The chat panel itself still opens at the newest message.
    useEffect(() => {
        if (selectedUser === null) return;
        const block = document.getElementById("waChatBlock");
        if (!block) return;
        const TOP_BAR = 62; // fixed navbar height
        const GAP = 10;
        const target = block.getBoundingClientRect().top + window.scrollY - TOP_BAR - GAP;
        window.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
    }, [selectedUser]);

    // Pill-style toggle (design only)
    const getButtonStyles = (index) => ({
        flex: 1,
        minHeight: 32,
        borderRadius: 5,
        border: "none",
        textTransform: "none",
        fontSize: 13.5,
        fontWeight: 700,
        px: 1.5,
        color: activeButton === index ? "#fff" : "#475569",
        bgcolor: activeButton === index ? "#2563eb" : "transparent",
        boxShadow: activeButton === index ? "0 4px 10px -4px rgba(37,99,235,0.6)" : "none",
        "&:hover": {
            border: "none",
            bgcolor: activeButton === index ? "#1d4ed8" : "#e2e8f0",
        },
    });


    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                p: { xs: 0, sm: 1 },
                pt: { xs: 1, sm: 2 },
                pb: 1,
            }}
        >
            <Card
                sx={{
                    width: "100%",
                    maxWidth: 1400,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 3,
                    border: "1px solid #e9edf2",
                    boxShadow: "0 1px 3px rgba(16,24,40,0.06)",
                }}
            >
                {/* Page header (design only) */}
                <Stack direction="row" alignItems="center" spacing={1.5} sx={{ px: { xs: 1.5, sm: 2.5 }, pt: { xs: 1.5, sm: 2 }, pb: 1 }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            width: 42,
                            height: 42,
                            borderRadius: 2.5,
                            color: "#fff",
                            background: "linear-gradient(135deg, #198754, #45c57f)",
                        }}
                    >
                        <ForumOutlinedIcon />
                    </Avatar>
                    <Box>
                        <Typography variant="h6" fontWeight={800} color="#0f172a" lineHeight={1.2}>
                            Messages
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Chat with your WhatsApp contacts in real time
                        </Typography>
                    </Box>

                    {/* Chat counts (display only, from the loaded list) */}
                    <Stack direction="row" spacing={1} sx={{ ml: "auto !important", display: { xs: "none", sm: "flex" } }}>
                        <Stack direction="row" alignItems="center" spacing={0.75} sx={{ px: 1.5, py: 0.6, borderRadius: 5, bgcolor: "#f1f5f9", border: "1px solid #e2e8f0" }}>
                            <ForumOutlinedIcon sx={{ fontSize: 16, color: "#475569" }} />
                            <Typography variant="body2" fontWeight={800} color="#0f172a">{waMessageContacts?.length || 0}</Typography>
                            <Typography variant="body2" color="text.secondary">chats</Typography>
                        </Stack>
                        {waMessageContacts?.some((c) => Number(c.unread) > 0) && (
                            <Stack direction="row" alignItems="center" spacing={0.75} sx={{ px: 1.5, py: 0.6, borderRadius: 5, bgcolor: "#fef2f2", border: "1px solid #fecaca" }}>
                                <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "#ef4444" }} />
                                <Typography variant="body2" fontWeight={800} color="#b91c1c">
                                    {waMessageContacts.filter((c) => Number(c.unread) > 0).length}
                                </Typography>
                                <Typography variant="body2" color="#b91c1c">unread</Typography>
                            </Stack>
                        )}
                    </Stack>
                </Stack>
                {/* Fixed Filter Panel - hidden during loading */}
                {status !== "loading" && (
                    <Box sx={{ mx: { xs: 1.5, sm: 2.5 }, mt: 1, p: { xs: 1.25, sm: 2 }, bgcolor: "#f8fafc", border: "1px solid #e9edf2", borderRadius: 3 }}>
                        <Grid container spacing={{ xs: 1.25, sm: 2 }}>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <FilterMultiSelect
                                    name="selectedBrachDeptValue"
                                    label="Branch Department"
                                    options={waContactUserFilterArr?.branchDepartments || []}
                                    value={selectedBrachDeptValue || []}
                                    onChange={handleMultiSelectChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <FilterMultiSelect
                                    name="selectedTagValue"
                                    label="Tag"
                                    options={waContactUserFilterArr?.tags || []}
                                    value={selectedTagValue || []}
                                    onChange={handleMultiSelectChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <FilterMultiSelect
                                    name="selectQrCodeValue"
                                    label="QR Code"
                                    options={waContactUserFilterArr?.qrCodes || []}
                                    value={selectQrCodeValue || []}
                                    onChange={handleMultiSelectChange}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                                <FilterMultiSelect
                                    name="selectOrganizationValue"
                                    label="Organization"
                                    options={waContactUserFilterArr?.organisations || []}
                                    value={selectOrganizationValue || []}
                                    onChange={handleMultiSelectChange}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Box>
                )}

                {/* Scrollable Content Panels */}
                <CardContent sx={{ px: { xs: 1.5, sm: 2.5 }, pt: 2 }}>
                    {
                        status === "loading" ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    backgroundColor: "#f5f5f5",
                                    width: "100%"
                                }}
                            >
                                <WhatsAppLoader status={status} />
                            </Box>
                        ) : (
                            <Grid
                                container
                                spacing={0}
                                id="waChatBlock" // page scrolls here when a chat is selected
                                sx={{ border: "1px solid #e9edf2", borderRadius: 3, overflow: "hidden", bgcolor: "#fff", scrollMarginTop: 72 }}
                            >
                                <Grid item size={{ xs: 12, md: 4, lg: 3 }} sx={{ borderRight: { md: "1px solid #e9edf2" } }}>
                                    {(!isMobile || (isMobile && selectedUser === null)) && (
                                        <Box sx={{ display: "flex", flexDirection: "column", height: PANEL_HEIGHT, minHeight: 380 }}>
                                            <Box
                                                sx={{
                                                    flexShrink: 0,
                                                    p: 1.25,
                                                    borderBottom: "1px solid #e9edf2",
                                                    backgroundColor: "#fff",
                                                    zIndex: 10,
                                                }}
                                            >
                                                <Stack direction="row" spacing={0.5} sx={{ mb: 1.25, p: 0.5, bgcolor: "#f1f5f9", borderRadius: 5 }}>
                                                    {[
                                                        { value: 0, label: "All", count: "" },
                                                        { value: 1, label: "Un-read", count: waMessageContacts.filter((item) => Number(item.unread) > 0).length === 0 ? "" : waMessageContacts.filter((item) => Number(item.unread) > 0).length },
                                                    ].map((item) => (
                                                        <Button
                                                            key={item.value}
                                                            variant="outlined"
                                                            sx={getButtonStyles(item.value)}
                                                            onClick={() => {
                                                                setState((prev) => ({ ...prev, activeButton: item.value })); dispatch(clearLoader());
                                                                dispatch(setSelectUser(null));
                                                                dispatch(
                                                                    getChatContacts({
                                                                        page: 1,
                                                                        limit: item.value === 0 ? 50 : 100,
                                                                        filterType: item.value,
                                                                        branch_department_ids: prepareFilterValues(selectedBrachDeptValue, waContactUserFilterArr.branchDepartments),
                                                                        tag_ids: prepareFilterValues(selectedTagValue, waContactUserFilterArr.tags),
                                                                        qr_code_ids: prepareFilterValues(selectQrCodeValue, waContactUserFilterArr.qrCodes),
                                                                        organisation_ids: prepareFilterValues(selectOrganizationValue, waContactUserFilterArr.organisations),
                                                                        search: searchUser?.trim() || "",
                                                                    })
                                                                );
                                                            }}
                                                        >
                                                            {item.label}
                                                            {item.count !== "" && (
                                                                <Box
                                                                    component="span"
                                                                    sx={{
                                                                        ml: 0.75,
                                                                        minWidth: 20,
                                                                        height: 20,
                                                                        px: 0.6,
                                                                        borderRadius: 5,
                                                                        fontSize: 11.5,
                                                                        fontWeight: 800,
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        color: activeButton === item.value ? "#2563eb" : "#fff",
                                                                        bgcolor: activeButton === item.value ? "#fff" : "#ef4444",
                                                                    }}
                                                                >
                                                                    {item.count}
                                                                </Box>
                                                            )}
                                                        </Button>
                                                    ))}
                                                </Stack>

                                                <TextField
                                                    fullWidth
                                                    placeholder="Search or start new chat"
                                                    value={searchUser}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (!value.startsWith(" ")) {
                                                            setState((prev) => ({ ...prev, searchUser: value }));
                                                        }
                                                    }}
                                                    size="small"
                                                    sx={{ "& .MuiOutlinedInput-root": { ...fieldRootSx, bgcolor: "#f8fafc", fontSize: 14 } }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon sx={{ color: "#2563eb", fontSize: 20 }} />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Box>

                                            <div
                                                id="scrollableDiv"
                                                style={{
                                                    width: "100%",
                                                    flex: 1,
                                                    minHeight: 0,
                                                    overflow: "auto",
                                                    background: "#fff",
                                                }}
                                            >
                                                <InfiniteScroll
                                                    dataLength={waMessageContacts?.length || 0}
                                                    next={fetchNext}
                                                    hasMore={hasMore}
                                                    loader={
                                                        loading && (
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "center",
                                                                    alignItems: "center",
                                                                    height: "50px",
                                                                }}
                                                            >
                                                                <Typography variant="caption" color="text.secondary">Loading more...</Typography>
                                                            </Box>)
                                                    }
                                                    endMessage={
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                height: "50px",
                                                            }}
                                                        ><Typography variant="caption" color="#94a3b8">No more contacts</Typography></Box>}
                                                    scrollableTarget="scrollableDiv"
                                                >
                                                    {
                                                        loading === true ? "" : <ChatContacts
                                                            waMessageContacts={
                                                                waMessageContacts
                                                            }
                                                        />
                                                    }

                                                </InfiniteScroll>
                                            </div>
                                        </Box>
                                    )}
                                </Grid>

                                <Grid item size={{ xs: 12, md: 8, lg: 9 }}>
                                    {(!isMobile || (isMobile && selectedUser !== null)) && (
                                        <Grid container spacing={0}>
                                            <Grid item size={{ xs: 12, md: 12 }}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        height: PANEL_HEIGHT,
                                                        minHeight: 380,
                                                        overflow: "hidden",
                                                        width: "100%",
                                                    }}
                                                >
                                                    {/* Header - Fixed */}
                                                    <Box
                                                        sx={{
                                                            flexShrink: 0,
                                                            borderBottom: "1px solid #e9edf2",
                                                            backgroundColor: "#fff",
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        <SocketProvider />
                                                        {selectedUser !== null && <ConvoNavBar />}
                                                    </Box>

                                                    {/* Scrollable Body */}
                                                    <Box
                                                        sx={{
                                                            flex: 1,
                                                            overflow: "auto",
                                                            backgroundColor: "#efeae2", // WhatsApp wallpaper base colour
                                                            p: { xs: 1.25, sm: 2 },
                                                            display: "flex",
                                                            flexDirection: "column-reverse", // 👈 important for chat (newest at bottom)
                                                            gap: 1,
                                                            backgroundImage: `url(${convoBg})`, // real WhatsApp doodle wallpaper (also behind the empty state)
                                                            backgroundRepeat: "repeat", // tile the pattern
                                                            backgroundSize: "340px auto", // smaller doodles, like WhatsApp Web
                                                            backgroundPosition: "top left",
                                                        }}
                                                        id="scrollableChatDiv" // 👈 needed by InfiniteScroll
                                                    >
                                                        {/* Empty state when no chat is selected (design only) */}
                                                        {selectedUser === null && (
                                                            <Stack
                                                                alignItems="center"
                                                                spacing={1.5}
                                                                sx={{
                                                                    m: "auto",
                                                                    textAlign: "center",
                                                                    px: { xs: 2.5, sm: 4 },
                                                                    py: { xs: 3, sm: 3.5 },
                                                                    maxWidth: 440,
                                                                    borderRadius: 4,
                                                                    bgcolor: "rgba(255,255,255,0.86)",
                                                                    backdropFilter: "blur(2px)",
                                                                    border: "1px solid rgba(255,255,255,0.9)",
                                                                    boxShadow: "0 12px 32px -16px rgba(15,23,42,0.35)",
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        width: 84,
                                                                        height: 84,
                                                                        borderRadius: "50%",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        bgcolor: "#dcfce7",
                                                                        boxShadow: "0 0 0 10px #f0fdf4",
                                                                    }}
                                                                >
                                                                    <WhatsAppIcon sx={{ fontSize: 44, color: "#16a34a" }} />
                                                                </Box>
                                                                <Typography variant="h6" fontWeight={800} color="#0f172a" sx={{ pt: 1 }}>
                                                                    Select a chat to start messaging
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
                                                                    Choose a contact from the list on the left to view the conversation and reply on WhatsApp.
                                                                </Typography>
                                                            </Stack>
                                                        )}

                                                        {selectedUser !== null && (
                                                            <InfiniteScroll
                                                                dataLength={Object.values(waMessageChats?.[0]?.messages || {}).flat().length} // total messages currently loaded
                                                                next={fetchPreviousChat} // function to load more
                                                                hasMore={hasMoreChats} // boolean from Redux
                                                                inverse={true} // 👈 important for chat scroll-up loading
                                                                scrollableTarget="scrollableChatDiv" // 👈 matches Box id
                                                                style={{ display: "flex", flexDirection: "column-reverse" }}
                                                                loader={<p style={{ textAlign: "center" }}>Loading more messages...</p>}
                                                            >
                                                                {/* {selectedUser !== null && <Convo lastMsgRef={lastMsgRef} />} */}

                                                                {
                                                                    chatPage === 1 ? (
                                                                        loadingChats ? (
                                                                            <Box
                                                                                sx={{
                                                                                    display: "flex",
                                                                                    flexDirection: "column",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    height: "100%",
                                                                                    py: 2,
                                                                                }}
                                                                            >
                                                                                <CircularProgress size={30} color="primary" />
                                                                            </Box>
                                                                        ) : (
                                                                            selectedUser !== null && <Convo lastMsgRef={lastMsgRef} />
                                                                        )
                                                                    ) : (
                                                                        selectedUser !== null && <Convo lastMsgRef={lastMsgRef} />
                                                                    )
                                                                }
                                                            </InfiniteScroll>
                                                        )}
                                                    </Box>


                                                    {/* Footer - Fixed */}
                                                    <Box
                                                        sx={{
                                                            flexShrink: 0,
                                                            borderTop: "1px solid #e9edf2",
                                                            backgroundColor: "#fff",
                                                            zIndex: 10,
                                                        }}
                                                    >
                                                        {selectedUser !== null && <ConvoFooter scrollToLastMsg={scrollToLastMsg} />}
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        )
                    }
                </CardContent>
            </Card>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
            />
        </Box>
    );
}